import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "copy",
  class: "copyright"
}
const _hoisted_2 = { id: "year" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createTextVNode(" © 2022–")),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.year), 1),
    _createTextVNode(" Therma-Stor LLC. All Rights Reserved. App Version: " + _toDisplayString(_ctx.version), 1)
  ]))
}